import React, { useState } from 'react';
import Select from 'react-select';
import Offcanvas from 'react-bootstrap/Offcanvas';
import DtlsTab from './HCnote/DtlsTab';
import ClausesTab from './HCnote/ClausesTab';


const HCNoteTab = () => {
const [showAdd, setShowAdd] = useState(false);
const [showEdit, setShowEdit] = useState(false);

const handleShowAdd = (e) => {
e.preventDefault();
setShowAdd(true);
};

const handleShowEdit = (e) => {
e.preventDefault();
setShowEdit(true);
};

const handleCloseAdd = () => setShowAdd(false);
const handleCloseEdit = () => setShowEdit(false);

return (
    <>
        <div className="row-gap-2">
            <ul className="nav nav-pills mb-3 custom-tabs gap-0" id="pills-tab" role="tablist">

                <li className="nav-item" role="presentation">
                    <button className="nav-link active" id="Estimates-charges-tab" data-bs-toggle="pill" data-bs-target="#Estimates-charges-tab-pane" type="button" role="tab" aria-controls="Estimates-charges-tab-pane" aria-selected="false">HCNote Dtls</button>
                </li>
                <li className="nav-item" role="presentation">
                    <button className="nav-link" id="Estimates-profit-loss-tab" data-bs-toggle="pill" data-bs-target="#Estimates-profit-loss-tab-pane" type="button" role="tab" aria-controls="Estimates-profit-loss-tab-pane" aria-selected="false">HCNote Clauses</button>
                </li>
                {/* <li className="nav-item" role="presentation">
                    <button className="nav-link" id="Estimates-exchange-rates-tab" data-bs-toggle="pill" data-bs-target="#Estimates-exchange-rates-tab-pane" type="button" role="tab" aria-controls="Estimates-exchange-rates-tab-pane" aria-selected="false">Exchange Rate</button>
                </li> */}
            </ul>
            <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="Estimates-charges-tab-pane" role="tabpanel" aria-labelledby="Estimates-charges-tab" tabIndex="0">
                    <DtlsTab />
                </div>
                <div className="tab-pane fade" id="Estimates-profit-loss-tab-pane" role="tabpanel" aria-labelledby="Estimates-profit-loss-tab" tabIndex="0">
                    <ClausesTab/>
                </div>
                {/* <div className="tab-pane fade" id="Estimates-exchange-rates-tab-pane" role="tabpanel" aria-labelledby="Estimates-exchange-rates-tab" tabIndex="0">
                    <ExchangeRateTab />
                </div> */}

            </div>
        </div>
        <div className="row justify-content-end mt-3 gap-2">
        <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
            Save
        </button>
        <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
            Save & Close
        </button>
        <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
            Save & New
        </button>
        <button className="btn btn-primary text-xs w-fit" type="submit" onClick={(e)=>{e.preventDefault()}} >
            Close
        </button>

    </div>
    </>
)
};

export default HCNoteTab;